import { Link as RouterLink, useLocation } from "react-router-dom";
import { useAuth } from "@xinosolutions/xs-auth-react";
import ThemeToggle from "../GeneralComponents/ThemeToggle";
import CreateAccountLink from "./CreateAccountLink";
import PortalSessionLoader from "./PortalSessionLoader";
import ShellAccountActions from "../Header/ShellAccountActions";

export default function SiteHeader() {
  const { pathname } = useLocation();
  const { isAuthenticated, loading } = useAuth();

  const isActive = (path) => pathname === path;

  return (
    <header className="portal-header">
      <RouterLink to="/" className="portal-logo">
        Learnix Admin
      </RouterLink>

      <nav className="portal-nav" aria-label="Primary">
        <RouterLink to="/" className={isActive("/") ? "portal-link" : undefined}>
          Home
        </RouterLink>
        {loading ? null : isAuthenticated ? (
          <RouterLink
            to="/dashboard"
            className={isActive("/dashboard") ? "portal-link" : undefined}
          >
            Dashboard
          </RouterLink>
        ) : null}
      </nav>

      <div className="portal-header-actions">
        {loading && <PortalSessionLoader />}
        {!loading && !isAuthenticated && (
          <CreateAccountLink className="portal-btn portal-btn--primary">
            Get started
          </CreateAccountLink>
        )}
        {!loading && isAuthenticated && (
          <RouterLink to="/dashboard" className="portal-btn portal-btn--primary">
            Open dashboard
          </RouterLink>
        )}
        <ThemeToggle variant="header" />
        {!loading && isAuthenticated ? <ShellAccountActions /> : null}
      </div>
    </header>
  );
}
